import { useEffect, useMemo } from 'react';

class TapPay {
  cardSetup = (iframe_id, style, config) => {
    window.TPDirect.card.setup(iframe_id, style, config);
  };

  onCardUpdate = (callback) => {
    window.TPDirect.card.onUpdate(callback);
  };

  getDirectPayPrime = () => {
    return new Promise((resolve, reject) => {
      try {
        window.TPDirect.card.getPrime((result) => {
          if (result.status !== 0) {
            reject(result.msg);
          }

          resolve({
            prime: result.card.prime,
            bincode: result.card.bincode,
            lastfour: result.card.lastfour,
            issuer: result.card.issuer,
            type: result.card.type,
            funding: result.card.funding,
            cardidentifier: result.card_identifier,
            merchantReferenceInfo: result.merchant_reference_info,
          });
        });
      } catch (error) {
        reject(error);
      }
    });
  };
}

const useTapPay = ({ appId, appKey, env }) => {
  const TapPayInstance = useMemo(() => new TapPay(), []);

  useEffect(() => {
    window.TPDirect.setupSDK(appId, appKey, env);
  }, [appId, appKey, env]);

  return [TapPayInstance];
};

export default useTapPay;
